"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegStatus = void 0;
exports.LegStatus = {
    CANCELLED: 'CANCELLED',
    COMPLETED: 'COMPLETED',
    IN_PROGRESS: 'IN_PROGRESS',
    LOST_DAMAGED: 'LOST_DAMAGED',
    PENDING: 'PENDING',
    TENDERED: 'TENDERED'
};
//# sourceMappingURL=leg-status.js.map